export const LEGACY_FULFILLMENT_METHOD_STORAGE_KEY = "deliveryMethod";
export class LegacyFulfillmentMethodTypeStorageManager {
    constructor(availableFulfillmentMethods) {
        this.availableFulfillmentMethods = availableFulfillmentMethods;
    }
    store(_) {
        throw new Error("Method not implemented.");
    }
    restore() {
        const legacyFulfillmentMethodString = localStorage.getItem(LEGACY_FULFILLMENT_METHOD_STORAGE_KEY);
        let fulfillmentMethodString = '"Delivery"';
        if (legacyFulfillmentMethodString == null) {
            return null;
        }
        if (legacyFulfillmentMethodString === '"shipment"')
            fulfillmentMethodString = '"Delivery"';
        else if (legacyFulfillmentMethodString === '"no_contact_delivery"')
            fulfillmentMethodString = '"NoContactDelivery"';
        else if (legacyFulfillmentMethodString === '"pickup"')
            fulfillmentMethodString = '"Takeaway"';
        else if (legacyFulfillmentMethodString === '"dine_in"')
            fulfillmentMethodString = '"DineIn"';
        const fulfillmentMethodType = JSON.parse(fulfillmentMethodString);
        if (this.availableFulfillmentMethods.includes(fulfillmentMethodType)) {
            return fulfillmentMethodType;
        }
        if (this.availableFulfillmentMethods.length > 0) {
            return this.availableFulfillmentMethods[0];
        }
        return null;
    }
    erase() {
        throw new Error("Method not implemented.");
    }
}
